import en from "./en";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import th from "./th";

const resources = {
  en: {
    translation: en,
  },
  th: {
    translation: th,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    order: ["sessionStorage"],
    lookupLocalStorage: "i18nextLng",
    fallbackLng: "en",
    lng: sessionStorage.getItem("lang"),

    caches: ["sessionStorage"], // cache user language on
    excludeCacheFor: ["cimode"], // languages to not persist (cookie, sessionStorage)

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
